import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { FairInteractiveMap as FairInteractiveMapComponent } from '../../components/public/FairInteractiveMap';
import { identityModel } from '../../redux-modules/base/models';

function FairStaticMap({
  stand,
  pois,
  mapBgColor,
  onStandClickUrl,
  children,
}) {
  const stands = useMemo(() => Array.from({ length: 999 }, (_, i) => i + 1), []);

  const handleStandClick = useCallback(() => {
    if (onStandClickUrl) {
      const isInIframe = window.self !== window.top;
      if (isInIframe) {
        window.top.location.href = onStandClickUrl;
      } else {
        window.location.href = onStandClickUrl;
      }
    }
  }, [onStandClickUrl]);

  return (
    <FairInteractiveMapComponent
      stands={stands}
      pois={pois}
      standsInFocus={[stand]}
      bgColor={mapBgColor || '#292929'}
      disableBgColor="#505050"
      notInFocusOpacity={0.4}
      fingersToPan={2}
      withoutControls
      withoutZoom
      onlyFocusClickable
      onStandClick={onStandClickUrl ? handleStandClick : null}
    >
      {children}
    </FairInteractiveMapComponent>
  );
}

export { FairStaticMap };

FairStaticMap.propTypes = {
  stand: identityModel.isRequired,
  pois: PropTypes.arrayOf(PropTypes.string),
  mapBgColor: PropTypes.string,
  onStandClickUrl: PropTypes.string,
  children: PropTypes.shape({ id: PropTypes.string }),
};

FairStaticMap.defaultProps = {
  pois: [],
  mapBgColor: null,
  onStandClickUrl: null,
  children: null,
};
